import Home from './Home';
import About from './About';
import Education from './Education';
import Resume from './Resume';
import Projects from './Projects';
import Skills from './Skills';
import Achievements from './Achievements';
import Competitions from './Competitions';
import Leadership from './Leadership';
import Certificates from './Certificates';
import Contact from './Contact';

function App() {
  return (
    <div className="portfolio-wrapper">
      <Home />
      <About />
      <Education />
      <Resume />
      <Projects />
      <Skills />
      <Achievements />
      <Competitions />
      <Leadership />
      <Certificates />
      <Contact />
    </div>
  );
}

export default App;